// Alaine's Compass — starter packaging supplier directory.
    // Compiled July 2026 from supplier websites found via public search. Most sell online
    // nationally in case quantities. Prices, minimums, and stock change — confirm directly.

    export const PACKAGING_DIRECTORY = [
  {
    "city": "Lancaster",
    "id": "pk-001",
    "name": "Fillmore Container",
    "notes": "Sells jars, woozy bottles, and lids by the case — a go-to for sauce and preserves makers.",
    "products": [
      "glass bottles",
      "jars",
      "woozy/hot sauce bottles",
      "lids & closures"
    ],
    "source": "Supplier website",
    "state": "PA",
    "website": "https://www.fillmorecontainer.com/"
  },
  {
    "city": "Eagle",
    "id": "pk-002",
    "name": "Container and Packaging",
    "notes": "Online wholesaler with small case quantities across glass and plastic.",
    "products": [
      "glass bottles",
      "jars",
      "plastic containers",
      "lids & closures"
    ],
    "source": "Supplier website",
    "state": "ID",
    "website": "https://www.containerandpackaging.com/"
  },
  {
    "city": "Seattle",
    "id": "pk-003",
    "name": "Specialty Bottle",
    "notes": "No-minimum supplier of glass jars, bottles, and tins — startup friendly.",
    "products": [
      "glass bottles",
      "jars",
      "tins"
    ],
    "source": "Supplier website",
    "state": "WA",
    "website": "https://www.specialtybottle.com/"
  },
  {
    "city": "Saratoga Springs",
    "id": "pk-004",
    "name": "SKS Bottle & Packaging",
    "notes": "Large online catalog of containers and closures with case quantities.",
    "products": [
      "glass bottles",
      "jars",
      "plastic containers",
      "lids & closures"
    ],
    "source": "Supplier website",
    "state": "NY",
    "website": "https://www.sks-bottle.com/"
  },
  {
    "city": "Addison",
    "id": "pk-005",
    "name": "The Cary Company",
    "notes": "Broad container catalog including sauce bottles; sells single cases.",
    "products": [
      "glass bottles",
      "jars",
      "pails",
      "lids & closures"
    ],
    "source": "Supplier website",
    "state": "IL",
    "website": "https://www.thecarycompany.com/"
  },
  {
    "city": "Chicago",
    "id": "pk-006",
    "name": "Berlin Packaging",
    "notes": "Major national supplier with a dedicated hot-sauce/woozy line; better for growing volumes.",
    "products": [
      "glass bottles",
      "jars",
      "woozy/hot sauce bottles",
      "lids & closures"
    ],
    "source": "Supplier website",
    "state": "IL",
    "website": "https://www.berlinpackaging.com/"
  },
  {
    "city": "St. Louis",
    "id": "pk-007",
    "name": "TricorBraun",
    "notes": "National distributor across glass and plastic; good once volumes grow.",
    "products": [
      "glass bottles",
      "jars",
      "woozy/hot sauce bottles",
      "plastic containers"
    ],
    "source": "Supplier website",
    "state": "MO",
    "website": "https://www.tricorbraun.com/"
  },
  {
    "city": "Cleveland",
    "id": "pk-008",
    "name": "Kaufman Container",
    "notes": "Wholesale glass and plastic containers with decoration services.",
    "products": [
      "glass bottles",
      "jars",
      "plastic containers",
      "lids & closures"
    ],
    "source": "Supplier website",
    "state": "OH",
    "website": "https://www.kaufmancontainer.com/"
  },
  {
    "city": "Waterford",
    "id": "pk-009",
    "name": "Burch Bottle & Packaging",
    "notes": "Glass canning and storage jars by the case.",
    "products": [
      "glass bottles",
      "jars",
      "lids & closures"
    ],
    "source": "Supplier website",
    "state": "NY",
    "website": "https://www.burchbottle.com/"
  },
  {
    "city": "",
    "id": "pk-010",
    "name": "Glassnow",
    "notes": "Glass containers aimed at gourmet food and beverage brands.",
    "products": [
      "glass bottles",
      "jars"
    ],
    "source": "Supplier website",
    "state": "",
    "website": "https://www.glassnow.com/"
  },
  {
    "city": "",
    "id": "pk-011",
    "name": "ePac Flexible Packaging",
    "notes": "Digitally printed custom pouches with low minimums and fast turnaround.",
    "products": [
      "stand-up pouches",
      "flexible film"
    ],
    "source": "Supplier website",
    "state": "",
    "website": "https://epacflexibles.com/"
  },
  {
    "city": "Evansville",
    "id": "pk-012",
    "name": "ePackage Supply",
    "notes": "Custom printed stand-up pouches with low MOQ and free design help.",
    "products": [
      "stand-up pouches",
      "plastic containers"
    ],
    "source": "Supplier website",
    "state": "IN",
    "website": "https://epackagesupply.com/"
  },
  {
    "city": "",
    "id": "pk-013",
    "name": "Packhelp",
    "notes": "Custom-branded pouches and boxes at startup-friendly minimums.",
    "products": [
      "stand-up pouches",
      "custom boxes",
      "labels"
    ],
    "source": "Supplier website",
    "state": "",
    "website": "https://packhelp.com/"
  },
  {
    "city": "",
    "id": "pk-014",
    "name": "Cubit Packaging",
    "notes": "Custom printed resealable stand-up pouches with low minimums.",
    "products": [
      "stand-up pouches"
    ],
    "source": "Supplier website",
    "state": "",
    "website": "https://www.cubitpackaging.com/"
  },
  {
    "city": "",
    "id": "pk-015",
    "name": "Packing Pigeon",
    "notes": "Low-minimum custom pouches with free shipping.",
    "products": [
      "stand-up pouches",
      "labels"
    ],
    "source": "Supplier website",
    "state": "",
    "website": "https://www.packingpigeon.com/"
  },
  {
    "city": "Pleasant Prairie",
    "id": "pk-016",
    "name": "Uline",
    "notes": "Fast shipping on boxes, mailers, and general packaging supplies.",
    "products": [
      "shipping supplies",
      "plastic containers",
      "boxes"
    ],
    "source": "Supplier website",
    "state": "WI",
    "website": "https://www.uline.com/"
  },
  {
    "city": "Buford",
    "id": "pk-017",
    "name": "DFI - Solutions In Print",
    "notes": "Packaging and print solutions provider. Contact: Scott Bunson, Packaging Advisor — cell 770-919-6747. 2832 Oleander Street, Buford, GA 30519.",
    "products": [
      "printed packaging",
      "labels"
    ],
    "source": "Referral",
    "state": "GA",
    "website": "https://www.dfi-llc.com/"
  }
];
